import React from 'react';

import cl from './SavingAccounts.module.css'

import pigImg from '../../assets/img/pigImg.png'
import smarterImg from '../../assets/img/check-circle.svg'
import moneyHandsImg from '../../assets/img/money_hands.png'
import { useTranslation } from 'react-i18next';


const SavingAccounts = () => {
    const { t, i18n } = useTranslation();
    return (
        <div className={cl.main_wrapper}>
            <div className={cl.container_wrapper}>
                <div className={cl.main_info_container}>
                    <h1 className={cl.main_title}>
                        <span className={cl.title_small}>{t('saving_accounts_page.main_title_small')}</span>
                        {t('saving_accounts_page.main_title')}
                    </h1>
                    <div className={cl.main_descr_container}>
                        <p className={cl.main_descr}>
                            {t('saving_accounts_page.main_descr')}
                        </p>
                    </div>
                    <div className={cl.solution_container}>
                        <div className={cl.solution_img_wrapper}>
                            <img src={pigImg} alt="" />
                        </div>
                        <div className={cl.solution_descr_wrapper}>
                            <p className={cl.solution_descr}>
                                {t('saving_accounts_page.gbh_bank_descr')}
                            </p>
                        </div>
                    </div>
                </div>
                <div className={cl.save_smarter_container}>
                    <h2 className={cl.save_smarter_title}>
                        {t('saving_accounts_page.save_smarter_title')}
                    </h2>
                    <div className={cl.save_smarter_points_row}>
                        <div className={cl.save_smarter_item}>
                            <div className={cl.save_smarter_title_wrapper}>
                                <div className={cl.img_save_item_wrapper}>
                                    <img src={smarterImg} alt="" />
                                </div>
                                <h3 className={cl.save_smarter_item_title}>
                                    {t('saving_accounts_page.save_smarter_lists.item1.item_title')}
                                </h3>
                            </div>
                            <p className={cl.save_smarter_descr}>
                                {t('saving_accounts_page.save_smarter_lists.item1.item_descr')}
                            </p>
                        </div>
                        <div className={cl.save_smarter_item}>
                            <div className={cl.save_smarter_title_wrapper}>
                                <div className={cl.img_save_item_wrapper}>
                                    <img src={smarterImg} alt="" />
                                </div>
                                <h3 className={cl.save_smarter_item_title}>
                                    {t('saving_accounts_page.save_smarter_lists.item2.item_title')}
                                </h3>
                            </div>
                            <p className={cl.save_smarter_descr}>
                                {t('saving_accounts_page.save_smarter_lists.item2.item_descr')}</p>
                        </div>
                        <div className={cl.save_smarter_item}>
                            <div className={cl.save_smarter_title_wrapper}>
                                <div className={cl.img_save_item_wrapper}>
                                    <img src={smarterImg} alt="" />
                                </div>
                                <h3 className={cl.save_smarter_item_title}>
                                    {t('saving_accounts_page.save_smarter_lists.item3.item_title')}
                                </h3>
                            </div>
                            <p className={cl.save_smarter_descr}>
                                {t('saving_accounts_page.save_smarter_lists.item3.item_descr')}
                            </p>
                        </div>
                        <div className={cl.save_smarter_item}>
                            <div className={cl.save_smarter_title_wrapper}>
                                <div className={cl.img_save_item_wrapper}>
                                    <img src={smarterImg} alt="" />
                                </div>
                                <h3 className={cl.save_smarter_item_title}>
                                    {t('saving_accounts_page.save_smarter_lists.item4.item_title')}
                                </h3>
                            </div>
                            <p className={cl.save_smarter_descr}>
                                {t('saving_accounts_page.save_smarter_lists.item4.item_descr')}
                            </p>
                        </div>
                        <div className={cl.save_smarter_item}>
                            <div className={cl.save_smarter_title_wrapper}>
                                <div className={cl.img_save_item_wrapper}>
                                    <img src={smarterImg} alt="" />
                                </div>
                                <h3 className={cl.save_smarter_item_title}>
                                    {t('saving_accounts_page.save_smarter_lists.item5.item_title')}
                                </h3>
                            </div>
                            <p className={cl.save_smarter_descr}>
                               {t('saving_accounts_page.save_smarter_lists.item5.item_descr')}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div className={cl.smarter_route_background}>
                <div className={cl.route_container_wrapper}>
                    <p className={cl.route_descr}>
                        {t('saving_accounts_page.smarter_route_descr')}
                    </p>
                </div>
            </div>
            <div className={cl.saving_bank_container_background}>
                <div className={cl.saving_bank_container_wrapper}>
                    <div className={cl.left_saving_bank}>
                        <h4 className={cl.saving_bank_title}>
                            {t('saving_accounts_page.saving_container.saving_title')}
                        </h4>
                        <div className={cl.saving_bank_descr_wrapper}>
                            <p className={cl.saving_bank_descr}>
                                {t('saving_accounts_page.saving_container.saving_descr1')}
                            </p>
                            <p className={cl.saving_bank_descr}>
                                {t('saving_accounts_page.saving_container.saving_descr2')}
                            </p>
                            <p className={cl.saving_bank_descr}>
                               {t('saving_accounts_page.saving_container.saving_descr3')}
                            </p>
                        </div>
                    </div>
                    <div className={cl.right_saving_bank}>
                        <img src={moneyHandsImg} alt="" />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SavingAccounts;
